import { render, staticRenderFns } from "./UpdateVersion.vue?vue&type=template&id=017484c0&scoped=true"
import script from "./UpdateVersion.vue?vue&type=script&lang=js"
export * from "./UpdateVersion.vue?vue&type=script&lang=js"
import style0 from "./UpdateVersion.vue?vue&type=style&index=0&id=017484c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017484c0",
  null
  
)

export default component.exports